import type { RootState } from 'src/state';
import type { DialogContext } from './actions';
import type { DialogKeys, FolderDialogContext } from './types';

export function getShowDialog(state: RootState, key: DialogKeys): boolean {
  return state.ui.showDialog[key]?.show || false;
}

export function getDialogContext(
  state: RootState,
  key: DialogKeys
): DialogContext | { runId?: string } | undefined {
  return state.ui.showDialog[key]?.context;
}

export function getFolderDialogContext(state: RootState): FolderDialogContext | undefined {
  const context = state.ui.showDialog.folder?.context;
  if (context && typeof context === 'object' && 'folderId' in context) {
    return context as FolderDialogContext;
  }
  return undefined;
}

export function getLoadingIndicator(state: RootState, key: string): boolean {
  return state.ui.showLoadingIndicator[key] || false;
}

export function getView(state: RootState): 'grid' | 'list' {
  return state.user.folderView;
}

export function getClipboardCutFromFolderId(state: RootState): string {
  return state.ui.clipboardCutFromFolderId;
}

export function getClipboardCut(state: RootState): boolean {
  return state.ui.clipboardCutFromFolderId !== '';
}

export function getDisplayContent(state: RootState): boolean {
  return true;
}

export function getDisplayDeployments(state: RootState): boolean {
  return (
    state.user.role === 'teacher' || state.user.role === 'editor' || state.user.role === 'standard'
  );
}

export function getDisplayGroups(state: RootState): boolean {
  return state.user.role === 'teacher' || state.user.role === 'standard';
}

export function getDisplaySubscription(state: RootState): boolean {
  return state.user.role !== 'student';
}

export function getDisplayEmailPreferences(state: RootState): boolean {
  return state.user.role !== 'learner';
}

export function getDisplayFeedback(state: RootState): boolean {
  return state.user.role !== 'learner';
}

export function getDisplayChangePassword(state: RootState): boolean {
  return state.user.role !== 'learner';
}
